import { Chip } from '@mui/material';
import { usePostRequestCountPendingQuery } from '@carcareers/store';
import { useMemo } from 'react';

export const PostRequestNotification = () => {
  const { data } = usePostRequestCountPendingQuery(undefined, {
    pollingInterval: 300000, // 5 minutes
    skip: false,
    refetchOnMountOrArgChange: true,
  });

  const notificationChip = useMemo(() => {
    return data ? <Chip label={data} color="primary" size="small" /> : null;
  }, [data]);

  return notificationChip;
};

export default PostRequestNotification;
